let dynamicList = [
  {
    content: "艾融软件2025半年报可视化",
    url: "https://zzcx.cs.com.cn/app/h5/composite?id=7505c104a3734efaaba94004a5fe1ada",
  },
  {
    content: "艾融软件(920799)2025年可视化半年报",
    url: "https://fr.p5w.net/report/514758",
  },
  {
    content: "艾融软件企业现金管理软件获华为鲲鹏双认证，信创能力再进阶",
    url: "https://www.i2finance.net/#/internal?dynId=920799_06",
    isInternal: true, // 是否跳转至公司内部动态
    dynId: "920799_06", // 内部动态-动态编号
    dynContent: [
      "2025 年 8 月 1 日，上海艾融软件股份有限公司的企业现金管理软件成功通过华为技术有限公司 Kunpeng 920 V200 的相互兼容性测试认证，获得 KUNPENG COMPATIBLE 证书及认证徽标的使用权。与此同时，该软件完成 Kunpeng 920 V200 鲲鹏同辕开发技术认证，收获 KUNPENG NATIVE 证书及认证徽标使用权。这是继艾融软件该软件通过华为昇腾基础软硬件平台开发认证，并获得AscendNative认证证书后，再次获得华为的相关认证，不仅标志着艾融软件在技术创新上再次突破，更意味着其在信创领域的全流程能力实现了新的飞跃。",
      "Kunpeng 920 V200 作为华为推出的高性能服务器处理器，基于先进的 ARM 架构设计，采用 7nm 工艺制造，具备卓越的性能表现。其高性能、高吞吐、高集成、高能效的特性，为大数据、分布式存储和数据库等高负载场景提供了强大的并行计算能力，在金融、电信等中高端行业的自主创新进程中扮演着关键角色。此次艾融软件企业现金管理软件通过华为鲲鹏认证，证实了其基于 “鲲鹏硬件＋openEuler＋鲲鹏 DevKit + 鲲鹏 BoostKit” 构建的软件工程流水线，具备实现一套代码开发、多平台运行的强大能力。在认证过程中，艾融软件大胆采用国产代码编译器毕昇编译器、毕昇 JDK，进一步强化了全流程信创化能力，为金融科技行业的信创实践树立了新标杆。",
      "一直以来，艾融软件专注于金融科技领域，致力于为企业打造安全、高效、智能的财资管理解决方案。其企业现金管理软件融合前沿技术理念，能精准预测现金流，深度剖析资金使用效益，为企业资金调配提供科学依据，助力企业优化资金布局，降低运营成本。此次获得华为鲲鹏双认证，是对该软件产品质量与性能的高度认可，彰显了艾融软件在技术研发方面的深厚底蕴。",
      "认证期间，艾融软件研发团队全力以赴。从架构设计的反复雕琢，到算法的精细优化；从性能的持续调优，到功能的不断完善，团队历经多轮严苛测试，确保软件在华为 Kunpeng 920 V200 平台上稳定运行且性能卓越。华为专业认证团队也全程深度参与，为艾融软件提供全方位技术指导与资源支持，保障认证流程严谨规范。这两项认证对艾融软件具有重大意义。一方面，有助于提升公司市场竞争力与品牌影响力，赢得更多客户信赖与市场认可；另一方面，将激励艾融软件在金融科技领域持续探索创新，为企业客户带来更优质、高效的财资管理解决方案。未来，艾融软件将继续加大技术研发投入，深化与华为等行业领军企业的合作，积极拓展业务领域，为推动金融科技行业发展贡献更多力量，也为信创产业的蓬勃发展注入新动力。",
      "[img]https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/internal_920799_06.png",
    ],
  },
  {
    content: "国际星闪无线短距通信联盟秘书长曾国松一行莅临艾融软件总部",
    url: "https://www.i2finance.net/#/internal?dynId=920799_05",
    isInternal: true, // 是否跳转至公司内部动态
    dynId: "920799_05", // 内部动态-动态编号
    dynContent: [
      "2025年7月22日，国际星闪无线短距通信联盟（以下简称“星闪联盟”）秘书长曾国松率一行三人莅临艾融软件总部。本次来访聚焦“会员企业星闪落地实践、产业生态共建与联盟运营优化”三大议题，并就11月“2025国际消费电子创新展”（ICEE 2025）筹备交换了意见。",
      "艾融软件首先介绍了公司业务、客户、产品等情况，并汇报了在与金融机构客户合作中发现的星闪方面客户需求以及在推广星闪技术中存在的一些难点，并对联盟的运营提出了建议。",
      "星闪联盟秘书长曾国松及产业推广部王孝主任通报了联盟近期的工作安排，并与艾融软件相关人员深入讨论了星闪在金融行业落地实践的相关技术和市场问题，并希望艾融软件在星闪金融应用领域的标准制定、产业生态共建等方面发挥更大的作用。",
      "此次访问进一步巩固了艾融软件在星闪生态中的“技术+场景”双领先定位。公司将在联盟指导下，持续加码星闪 2.0 相关应用研发，携手上下游伙伴共筑金融短距无线通信新场景、新应用。",
      "[img]https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/internal_920799_05.jpeg",
    ],
  },
  {
    content: "艾融软件亮相“北交所企业韧性成长论坛”：以自主可控技术夯实金融IT龙头地位",
    url: "https://www.i2finance.net/#/internal?dynId=920799_04",
    isInternal: true, // 是否跳转至公司内部动态
    dynId: "920799_04", // 内部动态-动态编号
    dynContent: [
      "2025年7月18日，艾融软件董事会秘书王涛受邀出席“北交所企业韧性成长与价值跃升”圆桌论坛，向数十家机构投资者系统展示公司在金融科技赛道的最新成果与增长路径。王涛表示，公司已实现对20家系统重要性银行100%覆盖，并切入31家万亿级商业银行，客户壁垒持续抬升。",
      "技术研发层面，艾融软件2024年深度参与多家大型银行核心系统国产化改造，五款拳头产品通过华为鲲鹏认证；2025年6月，企业现金管理软件V5.0再获华为昇腾AI平台认证，成为金融信创关键节点上的标杆案例之一。鸿蒙生态方面，公司累计培养1149人次鸿蒙认证工程师，相关解决方案已在多家国有大行落地。人工智能板块，自研大模型平台与AI人脸识别一体机已实现商业化部署，为银行智能营销、风控、支付等场景全面赋能。同时，公司还在2025年成为了星闪国际联盟的常务理事单位。",
      "面对资本市场，艾融软件强调“用成长数据说话”。王涛现场列举鲲鹏、昇腾双认证、银行覆盖率、鸿蒙人才规模等硬核指标，论证公司在细分赛道的不可替代性。未来三年，研发投入将聚焦纯血鸿蒙适配、生成式大模型与量子通信金融场景落地，同时发力业务中台及核心系统建设，打开增量空间。",
      "谈及北交所投资逻辑，王涛建议投资者关注“扎实基本面+确定性成长”的优质标的，并表示艾融软件将以长期业绩和透明信披回馈市场信任。",
      "[img]https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/internal_920799_04.jpeg",
    ],
  },
  {
    content: "赋能企业并购，艾融软件受邀参加和勤易“专精特新”企业家俱乐部主题沙龙",
    url: "https://www.i2finance.net/#/internal?dynId=920799_03",
    isInternal: true, // 是否跳转至公司内部动态
    dynId: "920799_03", // 内部动态-动态编号
    dynContent: [
      "[img]https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/internal_920799_03.jpg",
      "2025 年 6 月 19 日，在和君上海总部和勤易 “专精特新” 企业家俱乐部举办了一场聚焦 “并购助力企业高质量发展” 的主题沙龙，艾融软件受邀参加。这场思想与智慧的盛宴，吸引了众多行业精英、专家学者以及企业家代表欢聚一堂，共同探寻并购在企业发展中的关键作用与实践路径。艾融软件作为受邀企业，带着对并购发展的热切期望，积极参与其中，收获满满。",
      "本次论坛深入剖析近十年 A 股、港股及中概股 IPO 融资规模变化趋势，揭示当前 A 股发行收紧、境外市场融资面临挑战的行业现状。论坛就当前一级市场退出压力凸显，如基金到期、DPI 回报要求、企业融资困境、减持限制等行业焦点，对照 2024 年 9 月 24 日中国证监会出台的《并购六条》，阐述政策对并购市场的积极影响，强调并购是企业突破估值瓶颈、获取竞争优势、为股东创造超额回报的战略工具。",
      "同时论坛还以《企业并购合同纠纷高频争议以及解决方案设计》为题，深入解读股东优先购买权的法律要点，结合实际案例，为企业在并购过程中规避法律风险提供了极具实操性的建议，助力企业保障并购交易的顺利进行。",
      "北京银行围绕《北京银行科创企业金融服务方案》展开主题分享，介绍了国内科创企业发展概况以及北京银行的私募股权基金合作模式，分享了多个成功落地案例，并重点推介特色金融产品 —— 科创人才贷款，为科创企业在并购发展过程中提供了有力的金融支撑。",
      "艾融软件以 “我是谁、我有什么、我缺什么” 的简洁明了方式，阐述了企业概况、资源优势以及合作需求。这种高效沟通方式使得企业家们能够快速了解彼此的关键信息，促进了资源的迅速对接和深入交流。",
      "本次沙龙活动为企业并购搭建了一个优质的资源交流平台，打破了企业之间的信息壁垒，让企业能够在这里找到潜在的合作伙伴、项目机会以及资金支持。在这个平台上，企业可以自由地分享并购经验和资源，探讨合作的可能性，共同推动企业并购的发展。",
      "艾融软件在本次沙龙活动中获益匪浅。通过参与活动，艾融软件深入了解了并购市场的最新趋势、政策法规以及法律风险防范措施，为企业的并购发展提供了重要的指导。同时，艾融软件也充分展示了自身在科技领域的独特优势与创新成果，与其他企业建立了广泛的联系，挖掘了众多潜在的并购合作机会。未来，艾融软件将继续秉持创新与合作的精神，积极借助资本与产业协同的力量，不断提升自身的核心竞争力，向着高质量发展的目标坚定迈进，在科技领域书写更加辉煌的篇章。",
    ],
  },
  {
    content: "艾融软件企业现金管理软件 V5.0 荣获昇腾 AI 认证",
    url: "https://www.i2finance.net/#/internal?dynId=920799_02",
    isInternal: true, // 是否跳转至公司内部动态
    dynId: "920799_02", // 内部动态-动态编号
    dynSubhead: "",
    dynContent: [
      "[h2]开启智能财资管理新纪元",
      "2025 年 6 月 20 日，上海艾融软件股份有限公司在金融科技领域再铸里程碑，其重磅产品 —— 企业现金管理软件 V5.0，成功基于华为技术有限公司昇腾 AI 基础软硬件平台完成开发并通过昇腾应用开发技术认证，一举获得 Ascend Native 认证证书及认证徽标使用权，有效期至 2028 年 6 月。",
      "这一卓越成就，是艾融软件与华为深度协同的结晶，更是企业财资管理智能化征程的关键落子。",
      "上海艾融软件股份有限公司，深耕金融科技多年，始终聚焦为企业打造安全、高效、智能的财资管理系统。此次通过认证的企业现金管理软件 V5.0，融合前沿 AI 技术，全方位革新企业现金管理体验。它能精准预测企业现金流，深度分析资金使用效益，为企业资金调配提供决策依据，助力企业优化资金布局，降低运营成本。",
      "华为昇腾 AI 基础软硬件平台，以澎湃的 AI 算力、卓越的能效表现及开放的生态架构，为千行百业智能化转型注入强劲动力。艾融软件的现金管理软件在其上完美适配，得益于昇腾平台强大的算力支撑，实现海量数据高效处理，复杂算法精准执行；凭借开放生态，与周边金融科技应用无缝对接，拓展业务边界。",
      "成功通过认证，绝非偶然。背后是艾融软件研发团队夜以继日的技术攻坚，从架构设计到算法优化，从性能调优到功能完善，历经多轮严苛测试，确保软件在昇腾平台上稳定运行、性能卓越。同时，华为专业认证团队全程深度参与，提供全方位技术指导与资源支持，确保认证流程严谨规范。",
      "此次认证，对艾融软件而言，是产品迈向国际先进水平的通行证，提升市场竞争力与品牌影响力，赢得客户信赖与市场认可；对华为昇腾生态而言，是拓展金融科技版图关键一步，丰富生态应用场景，为后续合作树立标杆。",
      "展望未来，上海艾融软件股份有限公司将携手华为，持续深化合作。一方面，不断优化企业现金管理软件，挖掘 AI 潜力，探索更多创新功能，如智能风险预警、自动化财务决策等；另一方面，基于昇腾 AI 平台，拓展更多金融科技产品线，覆盖企业财务管理全场景，助力企业财资管理智能化升级，为金融行业数字化转型贡献更大力量。",
      "在人工智能浪潮席卷各行业的当下，上海艾融软件股份有限公司企业现金管理软件 V5.0 通过昇腾 AI 认证，恰似一颗璀璨新星，照亮企业财资管理智能化道路，预示着金融科技领域迎来崭新发展格局。",
      "[img]https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/internal_920799_02_01.jpg,https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/internal_920799_02_02.jpg",
    ],
  },
  {
    content: "艾融软件晋升国际星闪联盟常务理事单位，共筑短距通讯新生态",
    url: "https://finance.stockstar.com/IG2025050700028823.shtml",
  },
  {
    content: "艾融软件完成北交所首批代码切换",
    url: "https://www.i2finance.net/#/internal?dynId=920799_01",
    isInternal: true, // 是否跳转至公司内部动态
    dynId: "920799_01", // 内部动态-动态编号
    dynContent: [
      "2025 年 5 月 6 日，北交所正式进入 “920” 时代，艾融软件（920799.BJ）作为北交所首批存量上市公司代码切换试点企业之一，其股票代码由 830799 变更为 920799。",
      "此次北交所启动存量上市公司代码切换工作，旨在解决北交所历史遗留的代码分散问题，提升北交所股票的辨识度与认同感。沿用新三板挂牌时期代码可能会造成投资者混淆，而启用北交所独立代码号段，能够提高上市公司辨识度，方便投资者交易，吸引更多优质企业加入板块。",
      "艾融软件专注于金融科技领域，为银行等金融机构提供数字化解决方案。其成功入选北交所首批代码切换试点企业，充分体现了公司在金融科技领域的领先地位和市场影响力。代码切换后，艾融软件的股票代码前三位变更为 920，后三位保持不变，这不仅提升了公司在资本市场的辨识度，也有助于投资者更加清晰地识别和关注公司股票，进一步增强公司在资本市场的吸引力和竞争力。",
      "北交所此次存量上市公司代码切换试点工作总体准备就绪，于 2025 年 5 月 6 日正式上线。自该日起，投资者对试点股票的交易委托、行情查询，市场主体对试点股票的业务办理等均使用切换后的证券代码。首批参与试点的公司共有 6 家，显示出北交所对市场规范化的重视，后续北交所将在试点切换上线运行平稳、具备整体切换基础后，为其他 242 只存量上市公司股票统一切换证券代码。",
    ],
  },
  {
    content: "全面推进鸿蒙生态合作 艾融软件2024年营业收入6.08亿元",
    url: "https://www.p5w.net/kuaixun/202504/t20250425_6354450.htm",
  },
  {
    content: "艾融软件2024年年报可视化",
    url: "https://zzcx.cs.com.cn/app/h5/composite?id=3f446a09ee5e45f88307fd00ae8b08a6",
  },
  {
    content: "艾融软件子公司入选上海市高成长企业",
    url: "https://hea.china.com/article/20231206/122023_1451525.html",
  },
  {
    content: "艾融软件荣获第二十五届金牛奖——金牛小巨人奖",
    url: "http://finance.jrj.com.cn.comxs.net/a/news/21090.html",
  },
  {
    content: "艾融软件被授予“上海市崇明区商业秘密保护示范点”",
    url: "https://hea.china.com/article/20231124/112023_1444657.html",
  },
  {
    content: "艾融软件基于大模型和数字人技术解决方案 荣获2023沪港台三地上银金融科技大赛最具潜力奖",
    url: "https://www.cet.com.cn/wzsy/cyzx/3482142.shtml",
  },
  {
    content: "艾融软件金融信创业务快速发展 积极把握信创市场机会 ",
    url: "https://finance.stockstar.com/IG2023090100009961.shtml ",
  },
  {
    content: "艾融软件半年报发布 积极布局人工智能未来业绩可期",
    url: "https://caifuhao.eastmoney.com/news/20230830115226050930570",
  },
  {
    content: "艾融软件半年报发布 净利润较去年同期增长53%",
    url: "https://www.cet.com.cn/wzsy/cyzx/3434321.shtml",
  },

  {
    content: "艾融软件上半年净利润增长53%：业绩加速跑 AI业务取得突破",
    url: "http://www.wabei.cn/Home/News/292150",
  },
  {
    content: "推动人工智能等技术在金融业务中的应用 艾融软件2023上半年盈利2357.96万元",
    url: "https://www.p5w.net/kuaixun/202308/t20230825_5722401.htm",
  },
  {
    content: "艾融软件披露2023年一季报 净利润较去年同期大涨55%",
    url: " https://finance.stockstar.com/IG2023042600029662.shtml",
  },
  {
    content: "艾融软件加入openGauss社区，“信创”又添新利器",
    url: "https://www.cet.com.cn/itpd/itxw/3335533.shtml",
  },
  {
    content: "艾融软件：金融数字化运营正当时",
    url: "https://finance.stockstar.com/IG2023030200005208.shtml",
  },
  {
    content: "艾融软件：克服疫情困难 业绩逆势飘红",
    url: "https://caifuhao.eastmoney.com/news/20230227204056474135010",
  },
  {
    content: "未来已来，“北交所金融科技第一股”艾融软件前景可期",
    url: "https://caifuhao.eastmoney.com/news/20230222155829923825450",
  },
  {
    content: "艾融软件宣布通过百度智能云接入文心一言能力 打造艾融金融人工智能全系产品/服务",
    url: "https://www.cet.com.cn/itpd/itxw/3326523.shtml",
  },
  {
    content: "艾融软件宣布通过百度智能云接入文心一言能力 打造艾融金融人工智能全系产品/服务",
    url: "https://caifuhao.eastmoney.com/news/20230220120656127321140",
  },
  {
    content: "艾融软件宣布通过百度智能云接入文心一言能力 打造艾融金融人工智能全系产品/服务",
    url: "https://finance.stockstar.com/IG2023022000002656.shtml",
  },
  {
    content: "未来已来:艾融软件持续加码数字经济相关产品研发创新",
    url: " https://caifuhao.eastmoney.com/news/20230131083847561066540",
  },
  {
    content: "艾融软件获2021年度金牛北交所公司奖",
    url: "https://caifuhao.eastmoney.com/news/20221230160458320280310",
  },
  {
    content: "金融数字化转型，艾融软件推出深度解决方案",
    url: "https://caifuhao.eastmoney.com/news/20221202174406828914500",
  },
  {
    content: "艾融软件深度参与供销社数字化转型",
    url: "https://caijing.chinadaily.com.cn/a/202212/01/WS63883381a3102ada8b224c0e.html",
  },
  {
    content: "加速扩容 公募持仓提升！企业：北交所的影响是巨大的｜北交所一周年",
    url: "http://www.p5w.net/kuaixun/202211/t20221115_5595333.htm",
  },
  {
    content: "艾融软件：用专注专业态度提供定制服务",
    url: "https://paper.cnstock.com/html/2022-11/15/content_1692664.htm",
  },
  {
    content: "艾融软件入选北证50，金融信创业务步入“快车道”",
    url: "https://tech.china.com/article/20221110/112022_1175200.html",
  },
  {
    content: "北证50+信创概念 艾融软件抢筹行情开启",
    url: "https://finance.eastmoney.com/a/202211092555485135.html",
  },
  {
    content: "上海市经济和信息化委员会提名我单位作为第一完成单位申报2022年度上海市科技进步奖的情况公示",
    url: "National S&T Progress Award.jpeg",
  },
  {
    content: "艾融软件中标某行普惠业务需求项目 开启银行业务需求引领技术开发新模式",
    url: "https://finance.eastmoney.com/a/202207122446932358.html",
  },
  {
    content: "艾融软件全资子公司中标银联商务项目",
    url: "https://news.cnstock.com/news,bwkx-202207-4916837.htm",
  },
  {
    content: "携手北理工 艾融软件加入元宇宙人才培养大潮",
    url: "https://finance.eastmoney.com/a/202207042433851977.html",
  },
  {
    content: "艾融软件推出“眼神支付”产品,落地元宇宙数字人民币支付场景应用",
    url: "https://finance.eastmoney.com/a/202206272425917137.html ",
  },
  {
    content: "艾融软件普惠小微深度数字化立体解决方案 助力银行支持实体经济",
    url: "http://www.cinic.org.cn/zgzz/qy/1309856.html ",
  },
  {
    content: "艾融软件突进汽车“智能座舱“软件业务 \n",
    url: "https://finance.eastmoney.com/a/202206202418281959.html",
  },
  {
    content: "深耕金融数字化转型，艾融软件旗下宜签网络与上海农商行再度携手！",
    url: "https://finance.eastmoney.com/a/202206152413849439.html ",
  },
  {
    content: "艾融软件董事长张岩喜获聘为元宇宙专业委员会委员",
    url: "https://tech.china.com/article/20220614/062022_1084881.html",
  },
  {
    content: "艾融软件强力推进复工复产 订单产能双双呈现强劲恢复态势",
    url: "http://www.ceh.com.cn/syzx/1494292.shtml ",
  },
  {
    content: "复工复产，艾融软件添助力—数字化风控秀出“硬核实力”",
    url: "https://www.cet.com.cn/itpd/itxw/3189497.shtml ",
  },
  {
    content: "艾融软件金融数字员工解决方案受到金融行业关注 ",
    url: "https://finance.eastmoney.com/a/202206062402432224.html ",
  },
  {
    content: "艾融软件智能OCR产品开拓金融数字化新领域 ",
    url: "http://news.ifeng.com/c/8GSV7IeQ2xv",
  },
  {
    content: "艾融软件深耕银行数字化转型市场，业务中台产品又一案例即将上线",
    url: "https://finance.eastmoney.com/a/202205302396256147.html",
  },
  {
    content: "艾融软件落地金融数字化经营解决方案",
    url: "http://www.cb.com.cn/index/show/gd/cv/cv1361616991499",
  },
  {
    content: "艾融软件持续助力推进银行金融信息系统自主可控",
    url: "https://finance.eastmoney.com/a/202205232388130720.html",
  },
  {
    content: "艾融软件：公司已进军汽车数字化行业领域",
    url: "https://www.p5w.net/kuaixun/202205/t20220518_5550036.htm",
  },
  {
    content: "艾融软件：公司2021年接连中标多家银行客户项目，目前在手订单充足",
    url: "https://www.p5w.net/kuaixun/202205/t20220518_5550037.htm",
  },
  {
    content: "艾融软件：汽车软件行业新客户2021年已实现营收 有望成为业务及利润新增长点",
    url: "https://www.p5w.net/kuaixun/202205/t20220518_5550132.htm",
  },
  {
    content: "艾融软件发力金融数字化转型深水区",
    url: " https://finance.eastmoney.com/a2/202205182383549397.html",
  },
  {
    content: "艾融软件数字人民币应用场景建设步入快车道",
    url: " https://finance.eastmoney.com/a/202205172381961525.html",
  },
  {
    content: "艾融软件推出全新活体风控引擎，有效优化人脸身份认证管理",
    url: "http://biz.ifeng.com/c/8G3dRjY27iR",
  },
  {
    content: "艾融软件系列产品全面兼容鸿蒙，助力软件国产化",
    url: "https://js.news.163.com/22/0511/12/H7394LD104249CU4.html",
  },
  {
    content: "2022年艾融软件稳步推进汽车数字化行业业务",
    url: "http://www.cinic.org.cn/zgzz/qy/1287398.html",
  },
  {
    content: "艾融软件金融信创业务实现超300%快速增长",
    url: "https://tech.china.com/article/20220507/052022_1062783.html",
  },
  {
    content: "发明专利达到十四项 艾融软件技术创新再添硕果",
    url: "https://www.sohu.com/na/544346309_121046563",
  },
  {
    content: "艾融软件一季度营收同比增长59%：连续9个季度实现增长 持续强化研发力度",
    url: "http://www.wabei.cn/Home/News/223691",
  },
  {
    content: "艾融软件连续9年通过ISO9001质量管理体系认证",
    url: "http://www.dzwww.com/xinwen/jishixinwen/202205/t20220505_10197917.htm",
  },
  {
    content: "危难时刻，艾融软件勇当守“沪”者_",
    url: "https://tech.china.com/article/20220429/042022_1059315.html",
  },
  {
    content: "艾融软件元宇宙金融领域应用研发取得亮眼成果",
    url: "https://bank.stockstar.com/IG2022042900004920.shtml",
  },
  {
    content: "艾融软件成功入选首批特色化示范性软件学院合作企业 ",
    url: "https://www.cet.com.cn/itpd/itxw/3170190.shtml",
  },
  {
    content: "艾融软件当选中国仿真学会元宇宙专业委员会成员单位",
    url: "http://biz.ifeng.com/c/8FbCgK3z87r",
  },
  {
    content: "艾融软件，助力身份证电子化金融应用",
    url: "https://www.cet.com.cn/itpd/itxw/3169757.shtml",
  },

  {
    content: "艾融软件元宇宙金融领域应用研发取得亮眼成果",
    url: "https://biz.ifeng.com/c/8FY7fgJqPeK",
  },
  {
    content: "艾融软件积极扩张战略见成效：2021年实现“加速跑”",
    url: "http://www.wabei.cn/Home/News/221844",
  },
  {
    content: "2021艾融软件可视化年报",
    url: "https://fr.p5w.net/report/324259",
  },
  {
    content: "九卦 | 张岩：危机是企业进化的关键时刻",
    url: "https://mp.weixin.qq.com/s/mc2CDg8pFyTz0XlV9uc7gA",
  },
  {
    content: "艾融软件大规模升级远程软件开发服务，助力银行疫情期间保运转 ",
    url: "http://biz.ifeng.com/c/8FPlG88hopk",
  },
  {
    content: "艾融董事长张岩成为北交所第一届行业咨询委员会委员",
    url: "https://www.cet.com.cn/wzsy/kjzx/3162883.shtml",
  },
  {
    content: "[年报]艾融软件2021年净利润5038.03万元 现金分红比例近70%",
    url: "https://www.p5w.net/kuaixun/202204/t20220422_5542028.htm",
  },
  {
    content: "艾融董事长张岩成为北交所第一届行业咨询委员会委员",
    url: "https://mp.weixin.qq.com/s/HZ3jm7_uWvhc6P0ZDc9YBg",
  },
  {
    content: "艾融软件：闪送交付商业银行APP战疫专属服务",
    url: "https://yq.stcn.com/yqsl/202204/t20220421_4396844.html",
  },
  {
    content: "艾融软件数字人民币业务已在多家商业银行实现落地",
    url: "http://www.cb.com.cn/index/show/gd/cv/cv1361600501490",
  },
];

// 遍历dynamicList数组，替换num值（公司动态：num越小，排在最前）
for (let i = 0; i < dynamicList.length; i++) {
  dynamicList[i].num = i + 1;
  if (i < 9) {
    dynamicList[i].num = "0" + (i + 1);
  }
}

export default {
  "get|/parameter/dynamicList": () => {
    return {
      status: 200,
      message: "success",
      data: dynamicList,
    };
  },
};
